export default __webpack_public_path__ + "media/design-system/form/assets/chevron-2a020ee8fe1cb393b9f9fbbd33c59804.svg";